import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { IModuleQuery } from 'app/library/module/interfaces/module.query.interface';
import { IEnvironment } from 'app/projects/core/src/lib/interfaces/environment.interface';
import { MAXBRAIN_ENVIRONMENT } from 'app/projects/core/src/lib/services/environment.token';
import { Observable } from 'rxjs';

export interface IModulesAndTotalCount {
    data: IModuleQuery[];
    pagination: {
        number_of_pages: number;
        number_of_results: number;
    };
}

@Injectable()
export class AllModulesApiService {
    constructor(private http: HttpClient, @Inject(MAXBRAIN_ENVIRONMENT) private environment: IEnvironment) {}

    findModules(
        filterValues: { [key: string]: string[] } = null,
        search = '',
        sortBy = '',
        sortOrder = '',
        pageSize = 10,
        pageIndex = 1,
        kind = '',
        ids = '',
        context = ''
    ): Observable<IModulesAndTotalCount> {
        let params = new HttpParams().set('page', pageIndex.toString()).set('limit', pageSize.toString());

        if (filterValues) {
            Object.keys(filterValues).forEach((key) => {
                if (filterValues[key].length) {
                    params = params.append(`${key}`, filterValues[key].toString());
                }
            });
        }

        if (search) {
            params = params.set('search', search);
        }

        if (sortBy && sortOrder) {
            params = params.set('sortBy', sortBy);
            params = params.set('sortOrder', sortOrder);
        }

        if (kind) {
            params = params.set('kind', kind);
        }

        if (ids) {
            params = params.set('ids', ids);
        }

        if (context) {
            params = params.set('context', context);
        }

        return this.http.get<IModulesAndTotalCount>(`${this.environment.apiUrl}/modules`, { params });
    }

    fetchIncludedModules(reportId: string, startDate: string, endDate: string, pageSize: number, pageNumber: number): Observable<IModulesAndTotalCount> {
        const params = new HttpParams().set('filter[startDate]', startDate).set('filter[endDate]', endDate).set('page', pageNumber).set('limit', pageSize);

        return this.http.get<IModulesAndTotalCount>(`${this.environment.apiUrl}/reporting/specifications/${reportId}/report-included-modules`, { params });
    }
}
